export default "__VITE_ASSET__29c4f67d__"